import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { LoginResponseDto } from '@/lib/api';

export function useMyComplianceSummary() {
    return useQuery({
        queryKey: ['compliance', 'my-summary'],
        queryFn: () => api.compliance.getMyComplianceSummary().then((r) => r.data),
        staleTime: 60_000,
    });
}

export function useStaffComplianceSummary(staffId: string) {
    return useQuery({
        queryKey: ['compliance', 'staff-summary', staffId],
        queryFn: () => api.compliance.getStaffSummary(staffId).then((r) => r.data),
        enabled: !!staffId,
        staleTime: 60_000,
    });
}

export function useComplianceBadge(session: LoginResponseDto): number {
    const isAdmin = !!session.scope?.organization;
    const hasActiveOrg = !!session.activeOrg?.id;

    const adminQuery = useQuery({
        queryKey: ['compliance', 'pending-review-count'],
        queryFn: () => api.compliance.getPendingReviewCount().then((r) => r.data),
        enabled: isAdmin && hasActiveOrg,
        staleTime: 60_000,
        retry: (failureCount, error) => failureCount < 3 && (error as { status?: number })?.status !== 403,
    });

    if (isAdmin) {
        return adminQuery.data?.pendingReviewCount ?? 0;
    }
    return 0;
}
